import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { UiModule } from '@freelancer/ui';
import { SuccessRedirectComponent } from './success-redirect.component';
import { InvitationActionModule } from '../../invitation-action/invitation-action.module';
import { FormLogoModule } from '../form-logo/form-logo.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    UiModule,
    FormLogoModule,
    InvitationActionModule,
  ],
  declarations: [SuccessRedirectComponent],
  exports: [SuccessRedirectComponent],
})
export class SuccessRedirectModule {}
